import * as React from 'react';

export const MidDay = function (props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" role="img" width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3.75V3M6 6L5.25 5.25M6 18L5.25 18.75M18 6L18.75 5.25M18 18L18.75 18.75M3.75 12H3M12 20.25V21M20.25 12H21M17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.10051 17.25 6.75 14.8995 6.75 12C6.75 9.10051 9.10051 6.75 12 6.75C14.8995 6.75 17.25 9.10051 17.25 12Z"
        stroke={color || '#333333'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
